import { StyleSheet, Text } from 'react-native'
import { Link } from 'expo-router'
import { CardPaymentsE2E } from '../e2e'
import { Routes } from '@/src/common/enums/routes'
import { mesaColorNames, typography } from '@/src/common/theme'

export function CardPaymentsComponentsAgreement() {
  return (
    <Text style={styles.agreementText} testID={CardPaymentsE2E.Ids.Press.ViewAutoAgreement}>
      By tapping "Set up Auto-pay", you confirm you have reviewed and agree to the{' '}
      <Link href={Routes.CardManagementAutoPayAgreement.route} style={styles.highlighted}>
        Consumer ACH Authorization and Agreement.
      </Link>
    </Text>
  )
}

const styles = StyleSheet.create({
  agreementText: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    marginVertical: 16,
    marginHorizontal: 8,
    paddingHorizontal: 8,
    ...typography.S,
  },
  highlighted: {
    color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
  },
})
